/**
 * Get the list of a user's available dates between 2 dates
 *
 * @param {httpClient} axios - handles http requests
 * @param {{fromDate: string, toDate: string}} param1
 * @return {Promise<{}>}
 */

const getAvailableDatesByPeriod = async (axios, {fromDate, toDate}) => {
  try {
    return await axios.get(`/user/dates/available?fromDate=${fromDate}&toDate=${toDate}`);
  } catch (error) {
    throw error;
  }
};

/**
 * Get the users list
 *
 * @param {httpClient} axios - handles http requests
 * @return {Promise<{}>}
 */

const getUsersList = async (axios) => {
  try {
    return await axios.get(`/user/users`);
  } catch (error) {
    throw error;
  }
};

/**

 * Create a new user
 *
 * @param {httpClient} axios - handles http requests
 * @param {{fullname: string, domainName: string, name: string, role: ('USER'|'ADMIN'), specialty: string, surname: string, username: string}} userRequestDto
 * @return {Promise<{}>}
 */
const createUser = async (axios, userRequestDto) => {
  try {
    return await axios.post(`/user`, userRequestDto);
  } catch (error) {
    throw error;
  }
};
/**
 * Get the user details
 *
 * @param {httpClient} axios - handles http requests
 * @param {{id: string}} param1
 * @return {Promise<{}>}
 */

const getUserDetails = async (axios, {id}) => {
  try {
    return await axios.get(`/user/${id}`);
  } catch (error) {
    throw error;
  }
};

/**
 * Delete a user
 *
 * @param {httpClient} axios - handles http requests
 * @param {{id: string}} param1
 * @return {Promise<{}>}
 */

const deleteUser = async (axios, {id}) => {
  try {
    return await axios.delete(`/user/${id}`);
  } catch (error) {
    throw error;
  }
};

/**
 * Search for sap users
 *
 * @param {httpClient} axios - handles http requests
 * @param {{name: string}} param1
 * @return {Promise<{}>}
 */

const searchSapUsers = async (axios, {name}) => {
  try {
    return await axios.get(`/user/users/search?name=${encodeURIComponent(name)}`);
  } catch (error) {
    throw error;
  }
};

/**
 * Get user profile
 *
 * @param {httpClient} axios - handles http requests
 * @return {Promise<{}>}
 */

const getUserProfile = async (axios) => {
  try {
    return await axios.get('/user/me');
  } catch (error) {
    throw error;
  }
};

export {
  getAvailableDatesByPeriod,
  getUsersList,
  getUserDetails,
  getUserProfile,
  deleteUser,
  createUser,
  searchSapUsers
};
